import React, { useState, useEffect } from "react";
import { Accordion, Card, Spinner } from "react-bootstrap";
import Home from "../Home";
import { fetchReportsList, downloadUserReport } from "./actions";

function Downloads() {
  const [loading, setLoading] = useState(true);
  const [reportsList, setReportsList] = useState([]);

  useEffect(() => {
    async function fetchReports() {
      try {
        sessionStorage.setItem("return_url", "/downloads")
        if(sessionStorage.getItem("token")) {
          await fetchReportsList().then((response) => {
            sessionStorage.setItem("return_url", "")
            if (response && response.length > 0) {
              setReportsList(response);
              setLoading(false);
            } else {
              setReportsList([]);
              setLoading(false);
            }
          });
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching reports list:", error);
        setLoading(false);
      }
    }
    
    fetchReports();
  }, []);

  const handleDownload = async (file) => {
    let payload = {
      file: file,
    };
    let fileName = file.split("/")[4];
    await downloadUserReport(payload).then((response) => {
      if (response.success === true) {
        let fileObj = response.data.file;
        fetch(fileObj)
          .then((res) => res.blob())
          .then((data) => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            link.click();
          });
      }
    });
  };
  return (
    <Home>
      <h2>Download Reports</h2>

      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            Downlaod Reports
          </Accordion.Header>
          <Accordion.Body>
            {loading ? (
              <Spinner animation="border" />
            ) : (
              <div className="table-responsive mb-0 hover-table max-height">
                <table
                  className="table report-table"
                  aria-describedby="table"
                >
                  <thead>
                    <tr>
                      <th>
                        <div className="cursor-pointer">Process Id</div>
                      </th>
                      <th>
                        <div className="cursor-pointer">Report name</div>
                      </th>
                      <th>
                        <div className="cursor-pointer">File name</div>
                      </th>
                      <th>
                        <div className="cursor-pointer">File size</div>
                      </th>
                      <th>
                        <div className="cursor-pointer">Created Date</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportsList &&
                      reportsList.map((report) => {
                        let fileName = report.file.split("/")[4];
                        return (
                          <tr key={report.process_manager_id} onClick={() => handleDownload(report.file)}>
                            <td>{report.process_manager_id}</td>
                            <td>
                              {report.report_type}
                              {report.user_type === "CA" ? "(CA)" : ""}
                            </td>
                            <td>
                              {fileName}
                              <button>
                                <img
                                  src="images/bxs-download.svg"
                                  alt="Menu"
                                />
                              </button>
                            </td>
                            <td>{report.file_size}</td>
                            <td>{report.created_at}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Home>
  );
}

export default Downloads;
